import { Box } from "@mui/material";

export default function EditorMenuContainer (props: { children: JSX.Element }) {
    return (
        <Box className='editor-menu' key="editor-menu">
                {props.children}         
        </Box>
    )
}